import { useEffect, useState } from 'react';

import { CustomCursor, LiquidDistortionFilter } from './components/ui/SharedUI';
import { TerminalButton } from './components/ui/Terminal';
import { Footer } from './components/ui/Footer';
import { LegalModal, type LegalDocType } from './components/ui/LegalModals';

import { HeroSection } from './components/sections/HeroSection';
import { TheShiftInterlude } from './components/sections/TheShiftInterlude';
import { ArchitectureSection } from './components/sections/ArchitectureSection';
import { CoreDivisions } from './components/sections/CoreDivisions';
import { TechStackMarquee, AutonomyStream, SystemMetrics } from './components/sections/Metrics';
import { SectionHeading } from './components/ui/SharedUI';
import { ConversationalContact } from './components/sections/ContactForm';
import { TeamSection } from './components/TeamSection';
import { PersonaGallery } from './components/sections/PersonaGallery';

function App() {
  const [activeLegalDoc, setActiveLegalDoc] = useState<LegalDocType>(null);

  useEffect(() => {
    // Disable right-click globally
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // Disable dragging globally
    const handleDragStart = (e: DragEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);

    // Dispatch a theoretical resize event to trigger useScroll recalculation after the layout completes
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);

  return (
    <>
      <LegalModal type={activeLegalDoc} onClose={() => setActiveLegalDoc(null)} />
      <CustomCursor />
      <LiquidDistortionFilter />
      <TerminalButton />

      <HeroSection />

      {/* 
        This wrapper is crucial for the "scroll over" effect. 
        It has a top margin of 100vh, pushing all its child content below the fold initially.
        Because it's relatively positioned with z-index, it naturally scrolls UP and OVER the fixed Hero.
        We add a solid `bg-background` so it completely opaque covers the Hero section as it scrolls over.
      */}
      <main className="relative z-10 w-full mt-[100dvh] bg-background">

        <TheShiftInterlude />
        <ArchitectureSection />
        <TechStackMarquee />
        <CoreDivisions />

        <AutonomyStream />
        <TeamSection />

        <PersonaGallery />
        <SystemMetrics />

        {/* DYNAMIC CONTACT SECTION */}
        <section id="contact" className="relative z-30 w-full pt-16 pb-32 lg:pt-24 lg:pb-48 px-6 border-t border-white/5 bg-[#020202]">
          <div className="max-w-7xl mx-auto">
            <SectionHeading title="Initiate Protocol" subtitle="Direct Line" />
            <div className="mt-[-1rem] lg:mt-[-2rem]">
              <ConversationalContact />
            </div>
          </div>
        </section>
      </main>

      <Footer onOpenLegal={setActiveLegalDoc} />
    </>
  );
}

export default App;
